<template>
  <page-header
    :title="crag.name"
    :back-to="backTo || '/outdoor'"
    :links="headerLinks"
    :refresh-key="unreadPublicationCount"
  >
    <template #title>
      <h1 class="text-h6 font-weight-black text-no-wrap">
        <client-only>
          <subscribe-btn
            :subscribe-id="crag.id"
            subscribe-type="Crag"
            :large="false"
            small
            :icon-size="20"
            :incrementable="true"
            class="vertical-align-sub"
          />
        </client-only>
        {{ crag.name }}
      </h1>
    </template>
  </page-header>
</template>
<script>
import { mdiInformationOutline } from '@mdi/js'
import { oblykOutdoorPanel } from '~/assets/oblyk-icons'
import PageHeader from '~/components/layouts/PageHeader'
import OblykApi from '~/services/oblyk-api/OblykApi'
const SubscribeBtn = () => import('~/components/forms/SubscribeBtn')

export default {
  name: 'CragPageHeader',
  components: { SubscribeBtn, PageHeader },
  props: {
    crag: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      unreadPublicationCount: 0
    }
  },

  computed: {
    headerLinks () {
      const mediaCount = this.crag.all_photos_count + this.crag.all_videos_count
      const guidesCount = this.crag.guide_books.paper_count + this.crag.guide_books.web_count + this.crag.guide_books.pdf_count
      return [
        {
          to: this.crag.path,
          title: null,
          icon: mdiInformationOutline
        },
        {
          to: `${this.crag.path}/publications`,
          title: null,
          badge: this.unreadPublicationCount,
          icon: oblykOutdoorPanel
        },
        {
          to: `${this.crag.path}/routes`,
          title: this.$t('components.crag.tabs.routes'),
          badge: this.crag.routes_figures.route_count > 0 ? this.crag.routes_figures.route_count : null
        },
        {
          to: `${this.crag.path}/photos`,
          title: this.$t('components.crag.tabs.media'),
          badge: mediaCount > 0 ? mediaCount : null
        },
        {
          to: `${this.crag.path}/guide-books`,
          title: this.$t('components.crag.tabs.guideBooks'),
          badge: guidesCount > 0 ? guidesCount : null
        },
        {
          to: `${this.crag.path}/links`,
          title: this.$t('components.crag.tabs.links'),
          badge: this.crag.link_count > 0 ? this.crag.link_count : null
        },
        {
          to: `${this.crag.path}/maps`,
          title: this.$t('components.crag.tabs.map')
        }
      ]
    },

    backTo () {
      return this.$store.getters['oblykEnvironment/getPreviousHubs'](this.$route.path, this.crag.path)
    }
  },

  mounted () {
    if (this.$auth.loggedIn) {
      this.getUnreadPublication()
    }
  },

  methods: {
    getUnreadPublication () {
      new OblykApi(this.$axios, this.$auth)
        .get('/publication_views/unread_count', { publishable_type: 'Crag', publishable_id: this.crag.id })
        .then((resp) => {
          this.unreadPublicationCount = resp.data
        })
    }
  }
}

</script>
